import { render } from "./middleLinks.vue?vue&type=template&id=72362627&scoped=true"
import script from "./middleLinks.vue?vue&type=script&lang=js"
export * from "./middleLinks.vue?vue&type=script&lang=js"

import "./middleLinks.vue?vue&type=style&index=0&id=72362627&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72362627"]])

export default __exports__